import { jsxs as m, jsx as t } from "react/jsx-runtime";
import { useLocaleText as g, useLanguage as y, Group as v, Paragraph as a } from "@ingeniorforeningen/figurine-core";
import '../../../assets/EventDateAndVenue.css';const x = "_root_1iejp_2", j = "_linkWrapper_1iejp_21", h = "_dateDisplayPrimary_1iejp_25", C = "_dateDisplaySecondary_1iejp_29", D = "_overlay_1iejp_33", k = "_content_1iejp_37", f = "_list_1iejp_43", A = "_dateArea_1iejp_55", S = "_divider_1iejp_59", P = "_registration_1iejp_64", L = {
  root: x,
  linkWrapper: j,
  dateDisplayPrimary: h,
  dateDisplaySecondary: C,
  overlay: D,
  content: k,
  list: f,
  dateArea: A,
  divider: S,
  registration: P
}, N = (l) => {
  const p = g(), { language: c } = y(), r = [], { venueName: n, venueAddress: s, duration: o, deadline: d, variant: i } = l;
  if (n) {
    const e = { text: "" }, _ = /* @__PURE__ */ t(
      a,
      {
        scale: 0.875,
        text: n,
        strong: !0,
        variant: i === "primary" ? "dark" : "light",
        lineClamp: 1,
        condensed: !0
      }
    );
    if (e.text = _, s) {
      const u = /* @__PURE__ */ t(
        a,
        {
          scale: 0.875,
          text: s,
          lineClamp: 2,
          variant: i === "primary" ? "dark" : "light",
          condensed: !0
        }
      );
      e.description = u;
    }
    r.push(e);
  }
  if (o) {
    const e = /* @__PURE__ */ t(
      a,
      {
        scale: 0.875,
        lineClamp: 1,
        condensed: !0,
        text: `Kl. ${o}`,
        strong: !0,
        variant: i === "primary" ? "dark" : "light"
      }
    );
    r.push({ text: e });
  }
  if (d) {
    const e = /* @__PURE__ */ m(v, { className: L.registration, children: [
      /* @__PURE__ */ t(
        a,
        {
          scale: 0.875,
          lineClamp: 1,
          condensed: !0,
          variant: i === "primary" ? "dark" : "light",
          strong: !0,
          text: p.registrationDeadline
        }
      ),
      /* @__PURE__ */ t(
        a,
        {
          scale: 0.875,
          lineClamp: 1,
          condensed: !0,
          variant: "spot",
          text: `${d.toLocaleString(c, {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit"
          })}`
        }
      )
    ] });
    r.push({ text: e });
  }
  return r;
};
export {
  L as E,
  N as getItems
};
